define('plugin/client-field/view/BuiltIn/ClientFieldBuiltInPhoneView',['require','plugin/additional-fields/view/AdditionalFieldItemView','lib/Utils','lib/view/mixin/IntlPhone'],function (require) {

    var Parent = require('plugin/additional-fields/view/AdditionalFieldItemView');
    
    var Utils = require('lib/Utils');
    var IntlPhone = require('lib/view/mixin/IntlPhone');

    /**
     * Client field item view
     *
     * @class ClientFieldBuiltInPhoneView
     * @todo Utils.getClientPhoneValue - is used correctly?
     */
    return Parent.extend({
        
        ui: {
            'input': ':input',
            'phoneInput' : ':input[name=phone]',
        },

        getTemplate: function () {
            return '#client_field_built_in_phone';
        },
        
        setValue: function () {
            var val = this.ui.input.val();
            this.getOption('clientModel').set('phone', val, {silent: true});
        },
        
        serializeData: function () {
            return _.extend({}, Parent.prototype.serializeData.apply(this), {
                'value': Utils.getClientPhoneValue(
                    this.getOption('clientModel').get('phone')
                ),
                'is_required': Config.getInstance().getOption('client_login_require_phone') == '1' ? 1 : 0,
                'error': this.getOption('error'),
                'country_prefix': this.getOption('clientModel').get('country_prefix'),
                'country_prefix_is_fixed': this.getOption('clientModel').get('country_prefix_is_fixed')
            });
        },
        
        /**
         * On render add custom views to regions
         */
        onRender: function () {
            var config = Config.getInstance();
            IntlPhone.showIntlPhone(this.ui.phoneInput, {
                nationalMode: true,
                countryPrefix: config.getOption('country_prefix'),
                countryPrefixId: config.getOption('country_prefix_id'),
                allowedPrefix: config.getOption('country_prefix_is_changeable') ? null : config.getOption('country_prefix'),
            });
        },
        
    });

});
